export default __webpack_public_path__ + "static/media/chevron-up.6d31c0a0.svg";